import { render, staticRenderFns } from "./reservationResume.vue?vue&type=template&id=5727c552&scoped=true&"
import script from "./reservationResume.vue?vue&type=script&lang=js&"
export * from "./reservationResume.vue?vue&type=script&lang=js&"
import style0 from "./reservationResume.vue?vue&type=style&index=0&id=5727c552&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5727c552",
  null
  
)

export default component.exports